import { IdTagUserType } from 'src/app/shared/enums/id-tag-user-type.enum';
import { SelectedAccessGroup } from './modals/create-charging-user-with-app-invitation.modal/create-charging-user-with-app-invitation.modal.component';
import { AccessGroupCarType } from 'src/app/shared/enums/access-group-car-type';
import { Guid } from 'guid-typescript';

export class CreateUserWithoutInvitationRequest {
  organizationId: number;
  departmentId: number;
  name: string;
  email: string;
  accessGroupIdentifiers: Array<string>;
  phoneNumber: string;
  deliveryAddress: string;
  userType: IdTagUserType;
  phoneCountryCode: number;
  darId: string;
}

export class SendUserInvitations {
  organizationId: number;
  departmentId: number;
  emails: Array<string>;
  accessGroupIdentifiers: Array<string>;
  carType?: AccessGroupCarType;
}

export class CreateUserWithAppInvitationRequest {
  organizationId: number;
  departmentId: number;
  name: string;
  phoneNumber: string;
  alias: string;
  timeFrom?: Date;
  timeTo?: Date;
  accessGroupIdentifiers: string[];
  phoneCountryCode: number;
  carType?: AccessGroupCarType;
}

export class InviteIdTagUserRequest {
  alias: string;
  phoneNumber: string;
  chargingUserIdentifier: string;
  accessGroups: SelectedAccessGroup[];
  phoneCountryCode: number;
}
